import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreateFirestopAddition = async (
  firestopItemId,
  firestopAdditionAttributes,
  firestopImagesToAdd
) => {
  const apiPath = `firestop-documentation/firestop/${firestopItemId}/create-firestop-addition`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      firestopAdditionAttributes,
      firestopImagesToAdd,
    },
  });

  const response = await axios(signedRequest);

  return response.data;
};
